import { defineStore } from "pinia";
import { fetchProductData } from "@/api/product"
import { fetchSingleProductData } from "@/api/product"
import { fetchProductType } from "@/api/product";

export const useProductStore = defineStore("product", {
    state: () => ({
        products: [],
        singleProduct: null,
        product_type:[]
    }),

    actions: {
        async loadProducts() {
            try {
                const res = await fetchProductData()
                this.products = res.data.data || []
            } catch (error) {
                console.error("Failed to load products:", error)
                this.products = []
            }
        },

        async loadSingleProduct(id) {
            try {
                const res = await fetchSingleProductData(id)
                this.singleProduct = res.data.data
            } catch (error) {
                console.error("Failed to load product:", error)
            }
        },

        async loadProductTypes(){
             try {
                const res = await fetchProductType()
                this.product_type = res.data.data
            } catch (error) {
                console.error("Failed to load product:", error)
            }
        }
    }
})